export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 12a9 9 0 11-18.001-.001A9 9 0 0121 12zm-2 0c0-3.86-3.14-7-7-7s-7 3.14-7 7 3.14 7 7 7 7-3.14 7-7zm-3.3 2.3l-1.41 1.41-3-3c-.18-.19-.29-.44-.29-.71V7h2v4.59l2.7 2.71z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};